<template>
  <div>
    <modals-container id="modal-person" name="modal" />
    <v-dialog/>
    <form class="class_add_con w622 col_2_1" data-vv-scope="form" @submit.prevent="validateForm('form')" style="min-height: auto;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <thead>
        <tr>
          <td width="74" align="right">姓名：</td>
          <td width="360" class="pl_10"><input type="text" name="name" class="put_add_text" placeholder="姓名" v-model="form.name"></td>
          <td rowspan="4" align="right" class="bt_10" style="position: relative;">
            <img v-if="form.photo && form.photo!==''" :src="form.photo"  width="151" height="151"/>
            <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'photo'" v-if="uploadOSSConf.STS!=null" @success = "OSSUploadSuccess"></UploadOSS>
          </td>
        </tr>
        <tr>
          <td align="right"><span><i>*</i> 帐号</span>：</td>
          <td class="pl_10"><input type="text" name="textfield3" disabled class="put_add_text"  placeholder="成员唯一标识，设定以后不支持修改"></td>
        </tr>
        <tr>
          <td width="74" align="right" class="bt2_10"><b>*</b>身份证：</td>
          <td width="360" class="pl_10"><input type="text" name="idCard" class="put_add_text" placeholder="身份证号" v-model="form.idCard"></td>
        </tr>
        <tr>
          <td align="right"  class="bt_10">性别：</td>
          <td class="bt_10 pl_10">
            <input type="radio" name="sex" value="0" v-model="form.sex"> 男　
            <input type="radio" name="sex" value="1" v-model="form.sex"> 女
          </td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td align="right" class="bt2_10">手机：</td>
          <td colspan="2" class="bt2_10 pl_10"><label></label>
            <!--select name="select" id="select">
              <option>+86</option>
            </select-->
            <input type="text" name="mobile" class="put_add_text" v-model="form.mobile"></td>
        </tr>
        <tr>
          <td align="right">座机：</td>
          <td colspan="2" class="pl_10"><input type="text" name="phone" class="put_add_text" v-model="form.phone"></td>
        </tr>
        <tr>
          <td align="right"  class="bt_10">邮箱：</td>
          <td colspan="2" class="bt_10 pl_10"><input type="text" name="email" class="put_add_text" v-model="form.email"></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td align="right" class="bt2_10"><b>*</b>部门：</td>
          <td colspan="2" class="bt2_10 pl_10">
            <input type="text" class="name_t modify_input" v-model="form.parent.name" disabled="disabled" />
            <a href="javascript:void(0)" class="name_ch modify_btn" style="margin-right: 10px;" @click="show1">修改</a>
          </td>
        </tr>
        <tr>
          <td align="right">职务：</td>
          <td colspan="2" class="pl_10"><input type="text" name="textfield6" class="put_add_text" v-model="form.post"></td>
        </tr>
        <tr>
          <td align="right">工号：</td>
          <td colspan="2" class="pl_10"><input type="text" name="" class="put_add_text" v-model="form.no"></td>
        </tr>
        <tr>
          <td align="right">身份：</td>
          <td colspan="2" class="pl_10">
            <input type="radio" name="grade" value="1" v-model="form.grade"> 普通成员
            <input type="radio" name="grade" value="2" v-model="form.grade"> 上级
          </td>
        </tr>
        </tfoot>
      </table>
      <div class="add_bt_foot">
        <!--input name="" type="button" value="保存并继续添加"/-->
        <input name="" type="submit" value="保存" />
        <input name="" class="hui_color" type="button" value="取消" @click="emit('closed')" />
      </div>
    </form>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import '@/utils/validator.js'
  import TreeSelect from '@/page/byl/sys/menu/treemenu.vue'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import { mapState } from 'vuex'
  import Bus from '@/utils/bus.js'
  export default {
    components: { UploadOSS },
    props: ['data'],
    created () {
      this.getMenus()
    },
    watch: {
      data (val) {
        this.form = val
        if (val.newparent) {
          this.form.parent = val.newparent
        } else {
          if (val.depList) {
            this.form.parent = val.depList[0].dep
          } else {
            this.form.parent = { name: '' }
          }
        }
      }
    },
    mounted () {
      var that = this
      this.$nextTick(() => {
        $(function () {
          setTimeout(function () {
            if (that.form.photo) {
              $('a.img_upload4').css({'background': 'none', 'width': '0', 'height': '0'})
              $('input.img_upload4').css({'width': '151px', 'height': '151px'})
            }
          }, 1000)
        })
      })
      this.getSTS()
      this.OSSUploadSuccess()
      this.form.parent = this.dept // 新增状态下将“部门”赋值
    },
    data () {
      return {
        form: {
          parent: {}
        },
        uploadOSSConf: { showMode: '1', style: 'img_upload4', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
      }
    },
    computed: {
      ...mapState('orgstructure', ['dept'])
    },
    methods: {
      emit (msg, p) {
        this.$emit(msg, p)
      },
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        var _dealParams = function () { // 处理发送给后台的数据结构
          if (bus.form.parent && bus.form.parent.id) {
            var o = {}
            o.depId = bus.form.parent.id
            bus.form.depList = [o]
          }
        }
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _dealParams()
            bus.confirmBox({
              yes: function () {
                bus.$emit('saved', bus.form)
                bus.$emit('closed')
                bus.$modal.hide('dialog')
              }
            })
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      show1 () {
        var that = this
        this.$modal.show(TreeSelect, {
          data: that.menus,
          yes: function (val) {
            if (that.form.parent) { delete that.form.parent }
            if (that.form.newparent) { delete that.form.newparent }
            that.$set(that.data, 'newparent', val[0]);
          }
        })
      },
      getMenus (filters) {
        var that = this
        api.get(config.bylApiPath, '/dep', null, function (r) { // 获取正常
          that.menus = r.data
        })
      },
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.$set(this.form, r.dom_id, r.res.requestUrls[0])
          $('a.img_upload4').css({'background': 'none', 'width': '0', 'height': '0'})
          $('input.img_upload4').css({'width': '151px', 'height': '151px'})
        }
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/group/person.vue